export default __webpack_public_path__ + "static/media/not-found.d22e973c.png";